// extracted by mini-css-extract-plugin
export default {"page":"page-LhJej","tab":"tab-Qkz2j","active":"active-w82a4"};